import React from 'react'
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner'
import {
  ActionContainer,
  NotificationCourses,
  NotificationDetails,
  NotificationHeadline,
  NotificationText,
  NotificationTimeStamp
} from '../style'
import NotificationActionButtons from './NotificationActionButtons'

const NotificationList = ({ notifications, studentCourses }) => {
  if (
    !notifications?.length || !studentCourses?.length
  ) return <LoadingSpinner />

  return (
    <>
      {notifications.map(notification => {
        const {
          id,
          headline,
          additionalDetails,
          actions,
          courses
        } = notification
        const notificationCourses =
          studentCourses.length > 1 ? courses.join(' · ') : ''

        return (
          <NotificationDetails key={id}>
            <NotificationHeadline>{headline}</NotificationHeadline>
            <NotificationText>{additionalDetails}</NotificationText>
            <ActionContainer>
              <NotificationActionButtons actions={actions} />
            </ActionContainer>
            <NotificationCourses>{notificationCourses}</NotificationCourses>
            <NotificationTimeStamp>9hrs ago</NotificationTimeStamp>
          </NotificationDetails>
        )
      })}
    </>
  )
}

export default NotificationList
